<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Marketplace İndirimleri</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-text-field v-model="search" append-icon="search" label="Ara" single-line hide-details></v-text-field>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="selectOnSale"
        :items="onSaleItems"
        item-value="id"
        item-text="value" 
        @change="initialize"
        hide-details
        label="Aktif/Pasif"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-btn color="primary" dark @click="initialize" class="mb-2">Ara</v-btn>
      <v-btn color="success" dark @click="showMissingDiscounts" class="mb-2">Eksik İndirimler</v-btn>
      <v-btn color="orange" dark @click="showActiveDiscounts" class="mb-2">Aktif İndirimler</v-btn>
      <v-btn color="primary" dark class="mb-2" to="/mpdiscount/detail">Yeni Ekle</v-btn>
    </v-toolbar>
    
    <!-- Ana İndirim Listesi -->
    <v-data-table
      :headers="headers"
      :loading="this.$store.state.progress"
      :rows-per-page-items="pageItems"
      :items="this.$store.state.mpDiscounts.all"
      :pagination.sync="pagination"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            class="px-0 text-xs-center"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <td class="px-0 text-xs-center">{{ props.item.id }}</td>
        <td class="px-0 text-xs-center">%{{ props.item.discountRate }}</td>
        <td class="px-0 text-xs-center">{{ formatDate(props.item.startDate) }}</td>
        <td class="px-0 text-xs-center">{{ formatDate(props.item.endDate) }}</td>
        <td class="px-0 text-xs-center">{{ formatTime(props.item.startTime) }} - {{ formatTime(props.item.endTime) }}</td>
        <td class="px-0 text-xs-center">{{ getDaysText(props.item) }}</td>
        <td class="px-0 text-xs-center">{{ props.item.isAllProduct ? 'Tüm Ürünler' : 'Seçili Ürünler' }}</td>
        <td class="px-0 text-xs-center" v-if="props.item.state">Aktif</td>
        <td class="px-0 text-xs-center" v-else>Pasif</td>
        <td class="px-0 text-xs-center">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>

    <!-- Eksik İndirimler Dialog -->
    <v-dialog v-model="missingDiscountsDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Ana Tabloda Olup MP'de Olmayan İndirimler</span>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="syncSelectedDiscounts" :loading="syncLoading">Seçilenleri Ekle</v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            v-model="selectedMissingDiscounts"
            :headers="missingDiscountHeaders"
            :items="this.$store.state.mpDiscounts.missingDiscounts"
            item-key="id"
            show-select
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>
                <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
              </td>
              <td>{{ props.item.id }}</td>
              <td>%{{ props.item.discountRate }}</td>
              <td>{{ formatDate(props.item.startDate) }}</td>
              <td>{{ formatDate(props.item.endDate) }}</td>
              <td>{{ props.item.isAllProduct ? 'Tüm Ürünler' : 'Seçili Ürünler' }}</td>
              <td v-if="props.item.state">Aktif</td>
              <td v-else>Pasif</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="missingDiscountsDialog = false">Kapat</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Aktif İndirimler Dialog -->
    <v-dialog v-model="activeDiscountsDialog" max-width="900px">
      <v-card>
        <v-card-title>
          <span class="headline">Şu Anda Aktif İndirimler</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="activeDiscountHeaders"
            :items="this.$store.state.mpDiscounts.activeDiscounts"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.id }}</td>
              <td>%{{ props.item.discountRate }}</td>
              <td>{{ formatDate(props.item.startDate) }}</td>
              <td>{{ formatDate(props.item.endDate) }}</td>
              <td>{{ formatTime(props.item.startTime) }} - {{ formatTime(props.item.endTime) }}</td>
              <td>{{ getDaysText(props.item) }}</td>
              <td>{{ props.item.isAllProduct ? 'Tüm Ürünler' : 'Seçili Ürünler' }}</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="activeDiscountsDialog = false">Kapat</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    pagination: {
      sortBy: "discountRate"
    },
    selectOnSale: { id: -1, value: "Tümü" },
    search: null,
    syncLoading: false,
    missingDiscountsDialog: false,
    activeDiscountsDialog: false,
    selectedMissingDiscounts: [],
    pageItems: [
      500,
      1000,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
    ],
    onSaleItems: [
      { id: -1, value: "Tümü" },
      { id: false, value: "Pasif" },
      { id: true, value: "Aktif" }
    ],
    headers: [
      {
        text: "Id",
        align: "left",
        value: "id"
      },
      { text: "İndirim Oranı", value: "discountRate" },
      { text: "Başlangıç Tarihi", value: "startDate" },
      { text: "Bitiş Tarihi", value: "endDate" },
      { text: "Saat Aralığı", value: "timeRange", sortable: false },
      { text: "Günler", value: "days", sortable: false },
      { text: "Ürün Kapsamı", value: "isAllProduct" },
      { text: "Durum", value: "state" },
      { text: "İşlem", value: "id", sortable: false }
    ],
    missingDiscountHeaders: [
      { text: "Id", value: "id" },
      { text: "İndirim Oranı", value: "discountRate" },
      { text: "Başlangıç Tarihi", value: "startDate" },
      { text: "Bitiş Tarihi", value: "endDate" },
      { text: "Ürün Kapsamı", value: "isAllProduct" },
      { text: "Durum", value: "state" }
    ],
    activeDiscountHeaders: [
      { text: "Id", value: "id" },
      { text: "İndirim Oranı", value: "discountRate" },
      { text: "Başlangıç Tarihi", value: "startDate" },
      { text: "Bitiş Tarihi", value: "endDate" },
      { text: "Saat Aralığı", value: "timeRange" },
      { text: "Günler", value: "days" },
      { text: "Ürün Kapsamı", value: "isAllProduct" }
    ]
  }),

  created() {
    //
  },

  methods: {
    async initialize() {
      await this.$store.dispatch("mpDiscounts/searchMpDiscount", {
        search: this.search,
        onSale: this.selectOnSale.id > -1 ? this.selectOnSale.id : null
      });
    },
    
    editItem(item) {
      window.open("/mpdiscount/detail/" + item.id, '_blank');
    },

    deleteItem(item) {
      if (confirm("Silmek İstediğinizden Emin Misiniz?")) {
        this.$store.dispatch("mpDiscounts/deleteMpDiscount", item);
      }
    },
    
    async showMissingDiscounts() {
      await this.$store.dispatch("mpDiscounts/getMissingDiscounts");
      this.missingDiscountsDialog = true;
      this.selectedMissingDiscounts = [];
    },

    async showActiveDiscounts() {
      await this.$store.dispatch("mpDiscounts/getActiveDiscounts");
      this.activeDiscountsDialog = true;
    },
    
    async syncFromMain() {
      this.syncLoading = true;
      try {
        await this.$store.dispatch("mpDiscounts/syncFromMainDiscounts");
        this.$store.commit('SET_MESSAGE', 'Ana tablodan senkronizasyon başarılı!');
        await this.initialize(); // Listeyi yenile
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Sync error:', error);
        this.$store.commit('SET_MESSAGE', 'Senkronizasyon sırasında hata oluştu!');
      } finally {
        this.syncLoading = false;
      }
    },
    
    async syncSelectedDiscounts() {
      if (this.selectedMissingDiscounts.length === 0) {
        alert('Lütfen en az bir indirim seçin!');
        return;
      }
      
      this.syncLoading = true;
      try {
        const discountIds = this.selectedMissingDiscounts.map(d => d.id);
        await this.$store.dispatch("mpDiscounts/syncFromMainDiscounts", discountIds);
        this.missingDiscountsDialog = false;
        this.$store.commit('SET_MESSAGE', 'Seçilen indirimler başarıyla eklendi!');
        await this.initialize(); // Listeyi yenile
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Sync selected error:', error);
        this.$store.commit('SET_MESSAGE', 'İndirim ekleme sırasında hata oluştu!');
      } finally {
        this.syncLoading = false;
      }
    },
    
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString('tr-TR');
    },

    formatTime(timeString) {
      if (!timeString) return '-';
      // TimeSpan format: "hh:mm:ss" -> "hh:mm"
      return timeString.substring(0, 5);
    },

    getDaysText(item) {
      const days = [];
      if (item.monday) days.push('Pzt');
      if (item.tuesday) days.push('Sal');
      if (item.wednesday) days.push('Çar');
      if (item.thursday) days.push('Per');
      if (item.friday) days.push('Cum');
      if (item.saturday) days.push('Cmt');
      if (item.sunday) days.push('Paz');
      
      return days.length === 7 ? 'Her Gün' : days.join(', ');
    }
  },
  
  async mounted() {
    await this.initialize();
  }
};
</script>
